import { FormikSwitchField } from 'lib/components/formik/FormikSwitchField';
import React from 'react';
import {
  FormProps,
  RowWrapper,
  Section,
  SectionTitle,
} from '../../../components/AdminFormComponents';
import { useTranslation } from 'react-i18next';

export const LandingPageBuilderSection = (props: FormProps) => {
  const { t } = useTranslation();
  const { setFieldValue, values } = props;
  const sectionTitle = t('Landing Page Builder');
  const switchLabel = t('Enable Landing Page Builder');

  return (
    <Section>
      <SectionTitle>{sectionTitle}</SectionTitle>
      <RowWrapper>
        <FormikSwitchField
          extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
          name='isUsingLandingPageDesign'
          label={switchLabel}
          onChange={() => {
            setFieldValue(
              'isUsingLandingPageDesign',
              !values.isUsingLandingPageDesign
            );
          }}
        />
      </RowWrapper>
    </Section>
  );
};
